import React from "react";
import { Link, Route, Routes, useMatch, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ListUser from "./views/listUser";
import CreateUser from "./views/createUser";
import ViewUser from "./views/viewUser";
import EditUser from "./views/editUser";
import Window from "../../elements/window";
import EditAccountUser from "./views/editAccountUser";
import "../style.scss";
import { useAppContext } from "../../../../AppContext";

function Client() {
  const match = useMatch("/app/user/*");
  const location = useLocation();
  // const basePath = match ? match.pathname.split("/*")[0] : "/app/user";
  const basePath = "/app/user";
  const { chimeraserv, user, components } = useAppContext();
  const props = { chimeraserv, user, components };
  const title = "Manage User | Chimera Solutions | Insights";

  const routes = [
    {
      name: "ListUser",
      path: "list",
      component: ListUser,
    },
    {
      name: "CreateUser",
      path: "create",
      auth: true,
      level: [0, 1],
      component: CreateUser,
    },
    {
      name: "ViewUser",
      path: "view/:uid",
      component: ViewUser,
    },
    {
      name: "EditUser",
      path: "edit/:uid",
      auth: true,
      level: [0],
      component: EditUser,
    },
    {
      name: "EditAccount",
      path: "edit-account/:uid",
      component: EditAccountUser,
    },
  ];

  // Helper to check if user is allowed for a route
  const isAllowed = (route) => {
    if (!route.auth) return true;
    return route.level.includes(props.user.data.level);
  };

  return (
    <div className="viewContainer">
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div
        className="heading"
        style={{
          justifyContent: "flex-end",
          marginBottom: "10px",
          padding: "12px",
        }}
      >
        {[0, 1].includes(props.user.data.level) ? (
          <Link to="/app/user/create">
            <FontAwesomeIcon className="icon" icon={["fas", "plus"]} /> Create
            New User
          </Link>
        ) : (
          <div />
        )}
        <Link to="/app/user/list">List of Users</Link>
      </div>
      <div className="viewBody">
        <Routes>
          <Route
            index
            element={
              <ListUser
                user={props.user}
                chimeraserv={props.chimeraserv}
                components={props.components}
              />
            }
          />

          {/* <Route
            path={basePath}
            element={
              <ListUser
                user={props.user}
                chimeraserv={props.chimeraserv}
                components={props.components}
              />
            }
          /> */}
          {routes.map((route, key) =>
            isAllowed(route) ? (
              <Route
                key={key}
                path={route.path}
                element={
                  <route.component
                    user={props.user}
                    chimeraserv={props.chimeraserv}
                    components={props.components}
                  />
                }
              />
            ) : (
              <Route
                key={key}
                path={route.path}
                element={
                  props.components.setting[0].component
                    ? React.createElement(props.components.setting[0].component)
                    : null
                }
              />
            )
          )}
          <Route
            path="*"
            element={
              props.components.setting[0].component
                ? React.createElement(props.components.setting[0].component)
                : null
            }
          />
        </Routes>
      </div>
    </div>
  );
}

export default Client;
